import { motion } from "framer-motion";
import KM from "../assets/optimized/mjkim-new.webp";

function HeroSection() {
  return (
    <section
      className="relative overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #FFFDF9 0%, #F8F3ED 50%, #EADCC8 100%)",
      }}
    >
      {/* Gold Glow */}
      <div
        className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full blur-3xl opacity-20"
        style={{ background: "#D4AF37" }}
      />

      {/* Pink Glow */}
      <div
        className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full blur-3xl opacity-10"
        style={{ background: "#D63384" }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-24">
        {/* Hero Content */}
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-center">
          {/* Text Side */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <p className="uppercase tracking-[3px] text-[#C8A46B] font-semibold mb-4">
              Marriage & Personal Development Coaching
            </p>

            <h1 className="text-4xl lg:text-6xl font-bold text-[#1F1F1F] leading-tight">
              Helping Couples 
              <span className="block text-[#D63384]">Build Stronger</span>
              <span className="block text-[#C8A46B]">Marriages God's Way</span>
            </h1>

            <p className="text-lg lg:text-xl text-gray-600 mt-8 leading-relaxed max-w-xl">
              Faith-based marriage and relationship coaching designed to help couples reconnect, communicate, heal, and grow with biblical wisdom and practical tools for everyday life.
            </p>

            <div className="mt-10 flex flex-col gap-4 max-w-md">
              <button
                className="
                  w-full
                  bg-[#C8A46B]
                  hover:bg-[#B08C57]
                  text-white
                  py-4
                  rounded-full
                  font-semibold
                  shadow-lg
                  hover:shadow-xl
                  transition-all
                  duration-300
                  hover:-translate-y-1
                "
              >
                Book Coaching Session
              </button>

              <button
                className="
                  w-full
                  bg-[#D63384]
                  hover:bg-[#BE2D73]
                  text-white
                  py-4
                  rounded-full
                  font-semibold
                  shadow-lg
                  hover:shadow-xl
                  transition-all
                  duration-300
                  hover:-translate-y-1
                "
              >
                Prepare for Marriage
              </button>

              <button
                className="
                  w-full
                  bg-white
                  border-2
                  border-[#C8A46B]
                  text-[#1F1F1F]
                  py-4
                  rounded-full
                  font-semibold
                  shadow-md
                  hover:bg-[#FFF7EC]
                  transition-all
                  duration-300
                  hover:-translate-y-1
                "
              >
                Learn More About Us
              </button>
            </div>
          </motion.div>

          {/* Photo Side */}
          <motion.div
            initial={{ opacity: 0, x: 75 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-white/40 rounded-[40px] blur-xl" />

            <img
              src={KM}
              alt="Marriage Coaches"
              className="
                relative
                rounded-[32px]
                shadow-[0_20px_60px_rgba(0,0,0,0.15)]
                w-full
                object-cover
              "
            />
          </motion.div>
        </div>
              <p className="text-lg lg:text-xl text-gray-600 mt-8 text-center">
                Maurice and Kim Johnson believe that marriage is not just hard work — it is heart work. With the right guidance, practical tools, and a surrendered heart, every relationship has the potential to not only survive, but flourish.
              </p>
        {/* Consultation Card */}
        <motion.div
          animate={{ y: [0, -8, 0] }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="
            mt-20
            mx-auto
            max-w-2xl
            bg-white/90
            backdrop-blur-md
            rounded-[32px]
            shadow-[0_15px_50px_rgba(0,0,0,0.08)]
            border-t-4
            border-[#C8A46B]
            px-10
            py-8
            text-center
          "
        >
          <p className="uppercase tracking-widest text-sm text-[#C8A46B] font-semibold">
            Complimentary Consultation
          </p>

          <h3 className="text-3xl font-bold text-[#1F1F1F] mt-3">
            Start Your Journey Together
          </h3>

          <p className="text-gray-600 mt-3">
            Schedule your free consultation today
          </p>

          <p className="text-4xl font-bold text-[#D63384] mt-4">931-561-7201</p>
        </motion.div>
      </div>
    </section>
  );
}

export default HeroSection;
